
export const getOptionsQuery = () => {
    const query = `
        query{
            transactionCategories
            paymentTypes
            paymentMethods
            expenseCategories
            allowedCurrencies
            availableTimezones
            otherRecurringBillItems
            reportSettings
            allReportColumns
            chartMomOptions
            chartGroupingOptions
            maintenanceCategories
            maintenanceStatuses
            allowedSmsBankTypes
            leaseExpiryReminderDays
            allPerms
            allAccountTypes
            userAccountType
            allMessageTypes
            userPerms {
                model
                view
                all
            }
        }
    `;
    return query;
}